export default __webpack_public_path__ + "assets/icon-calendar-blank.fdc4580d.svg";